<footer *ngIf="!thin">
	<div>
		<div>
			<h2><img [src]="'assets/iconContact.svg'" alt=""> Call us</h2>
			<p>Our consultants are available to assist you</p>
			<p><a href="tel:+27861736827">0861&nbsp;73&nbsp;68&nbsp;27</a></p>
			<a class="button" [routerLink]="['/contact']">Contact us</a>
		</div>
		<div>
			<h2><img [src]="'/assets/iconMap.svg'" alt=""> Our storage facilities</h2>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'honeydew']">Honeydew</a></p>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'pretoria']">Pretoria, Roseville</a></p>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'pretoria-hatfield']">Pretoria, Hatfield</a></p>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'sandton']">Sandton</a></p>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'centurion']">Centurion</a></p>
			<p><a class="footer-facility-link" [routerLink]="['/storage-facility', 'midrand']">Midrand</a></p>
		</div>
		<div>
			<h2><img [src]="'/assets/iconBlog.svg'" alt=""> Useful info</h2>
			<p><a [routerLink]="['/faqs']">FAQs</a></p>
			<p><a [routerLink]="['/moving-tips']">Packing &amp; moving tips</a></p>
			<p><a [routerLink]="['/free-move-in-transport']">Free move-in transport</a></p>
			<p><a [routerLink]="['/payment-terms']"> Payment terms</a></p>
			<p><a [routerLink]="['/blog']"> News &amp; articles</a></p>
		</div>
		<div>
			<h2><img [src]="'/assets/iconStorage.svg'" alt=""> About us</h2>
			<p><a [routerLink]="['/facility-standards']">Facility standards</a></p>
			<p><a [routerLink]="['/security']">Secure storage</a></p>
			<p><a [routerLink]="['/careers']">Careers</a></p>
		</div>
		<div>
			<h2><img [src]="'/assets/iconNewsletter.svg'" alt=""> Keep updated</h2>
			<p>Join our monthly newsletter for useful information and our latest specials.</p>
			<form ngNoForm method="POST" [action]="mailchimpFormAction">
				<input type="email" name="EMAIL">
				<input type="hidden" [name]="mailchimpHiddenField">
				<button type="submit">Subscribe now</button>
			</form>
			<!-- <script type='text/javascript' src='https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script> -->
			<!-- <script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';}(jQuery));var $mcj = jQuery.noConflict(true);</script> -->
		</div>
	</div>
</footer>

<footer class="copyright">
	<p>
		<a class="logo" [routerLink]="['/']"><img loading="lazy" [src]="'assets/logoFooterRENTASTORE.svg'" alt="RENT-A-STORE"></a>
		Copyright &copy; Rent-A-Store {{now|date:'yyyy'}}. All rights reserved.
		&nbsp; <a [routerLink]="['/privacy-statement']">Privacy Statement</a>
		&nbsp; <a href="javascript:window.cookieconsent.openPreferencesCenter()" id="open_preferences_center">Cookies preferences</a>
		<span class="social">
			<a target="_blank" href="https://www.facebook.com/rentastoreZA/"><img loading="lazy" [src]="'assets/iconFacebook.svg'" alt="Facebook"></a>
			{{'&emsp;'}}
			<a target="_blank" href="https://www.instagram.com/rentastore/"><img loading="lazy" [src]="'assets/iconInstagram.svg'" alt="Instagram"></a>
<!-- 			{{'&emsp;'}}
			<a target="_blank" href="https://twitter.com/rentastoreza"><img loading="lazy" [src]="'assets/iconTwitter.svg'" alt="Twitter"></a>
 -->			{{'&emsp;'}}
			<a target="_blank" href="https://www.youtube.com/channel/UCmnJmSlq6I5QVg_5nzWHo9w"><img loading="lazy" [src]="'assets/iconYouTube.svg'" alt="YouTube"></a>
		</span>
	</p>
</footer>

<ras-spinner [active]="busy" [messages]="null"></ras-spinner>
<ras-popup *ngIf="!!error_message" (close)="error_message = null" error>
	<p>{{error_message}}</p>
</ras-popup>